import { staticText } from 'utils/staticText';

const moneyHeroTranslation = staticText({
  brand_reward_stk_bka: {
    _: 'MoneyHero Reward',
    zh: 'MoneyHero獎賞價值',
  },
  brand_reward_product_modal: {
    _: 'MoneyHero Reward',
    zh: 'MoneyHero獎賞價值',
  },
  brand_reward_product_modal_cc: {
    _: 'MoneyHero Reward',
    zh: 'MoneyHero獎賞價值',
  },
  show_all_travel_insurance_products: {
    _: 'Show All Products',
    zh: '顯示所有產品',
  },
  show_all_car_insurance_products: {
    _: 'Show All Products',
    zh: '顯示所有產品',
  },
  apply_through: {
    _: 'Apply through MoneyHero and choose from :count premium rewards',
    zh: '「經MoneyHero申請,精選獎賞任你揀!獎賞選擇(:count) 」',
  },
  purchase_through: {
    _: 'Purchase through MoneyHero and choose from :count premium rewards',
    zh: '經MoneyHero投保 ，精選獎賞任你揀！獎賞選擇(:count)',
  },
  apply_through_stk_bka: {
    _: 'Apply through MoneyHero and choose from :count premium rewards (Actual Gift eligibility depends on the deposit amount provided in the terms and conditions)',
    zh: '經MoneyHero申請，精選獎賞任你揀！獎賞選擇 :count (實際獎賞資格須視乎條款及細則所列的存款金額而定)',
  },
  bank_gift: {
    _: `Bank Gift - On Top of MoneyHero's`,
    zh: '產品禮遇',
  },
  lender_gift: {
    _: `Lender Gift - On Top of MoneyHero's`,
    zh: '產品禮遇',
  },
  sta_bka_bank_gift: {
    _: `Provider Gift - On Top of MoneyHero's`,
    zh: '產品禮遇',
  },
  standout_tips: {
    _: 'MoneyHero Tips',
    zh: 'MoneyHero 理財建議',
  },
  standout_takeaways: {
    _: 'MoneyHero Takeaways',
    zh: 'MoneyHero 重點',
  },
  standout_perspective: {
    _: 'MoneyHero Expert Perspective',
    zh: 'MoneyHero 專家觀點',
  },
  lightdeal: {
    _: 'MoneyHero Lightning Deal',
    zh: 'MoneyHero 限時優惠',
  },
  reward_modal_loan_amount_with_end: {
    _: ':label :start - :end',
    zh: ':label :start - :end',
  },
  reward_modal_loan_amount_without_end: {
    _: ':label :start',
    zh: ':label :start',
  },
  reward_modal_tenure_with_end: {
    _: ':label :start - :end month tenure',
    zh: ':label :prefix:start :suffix - :prefix:end :suffix',
  },
  reward_modal_tenure_without_end: {
    _: ':label :start month tenure :suffix',
    zh: ':label :start :suffix',
  },
});
export default moneyHeroTranslation;
